import React from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

export default function GramPanchayatList({
  gramPanchayatList,
  setEditGramPanchayatDetails,
  setShowAddForm,
}) {
  const onClickEdit = (grampanchayat) => {
    setEditGramPanchayatDetails(grampanchayat);
    setShowAddForm(true);
  };
  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Gram Panchayat Name
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Sub Division Name
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Police Station
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Post Office
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Pin Code
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-right font-medium text-slate-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-slate-100 text-slate-600">
        {gramPanchayatList?.length > 0 &&
          gramPanchayatList.map((grampanchayat, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {grampanchayat.grampanchayatname}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {grampanchayat.subdivisionname}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {grampanchayat.policestation}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {grampanchayat.postoffice}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {grampanchayat.pincode}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(grampanchayat)}
                    aria-label="Edit GramPanchayat Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </TableWrapper>
  );
}
